import { useUserMembership, useNavigation } from 'src/hooks'
import { titleize } from 'src/utils'
import { AccountInfoRow, AccountInfoRowLabel } from './AccountInfoRow'
import TiaEssentialLogo from 'src/pages/AccountInfo/assets/TiaEssentialTierLogo'
import { TiaLogo } from 'src/components/MUIBased/TiaLogo'

export const Membership = () => {
    const { membership, isLoading } = useUserMembership()
    const { navigate } = useNavigation()

    const enableEditing = () => {
        navigate('/membership/change-cancel')
    }

    const interval = membership?.tier.price.interval
    const intervalLabel = interval === 'annual' ? 'year' : 'month'
    return (
        <AccountInfoRow
            title="Membership"
            isLoading={isLoading}
            onEdit={enableEditing}
        >
            <AccountInfoRowLabel onClick={enableEditing}>
                {membership &&
                    (() => {
                        switch (membership.tier.name) {
                            case 'Tia Essential':
                                return <TiaEssentialLogo />
                            case 'Tia':
                                return <TiaLogo />
                            case 'Tia Legacy':
                                return titleize(
                                    `${membership.tier.price.interval} ($${
                                        membership.tier.price.amount / 100
                                    }/${intervalLabel})`
                                )
                            default:
                                return null
                        }
                    })()}
            </AccountInfoRowLabel>
        </AccountInfoRow>
    )
}
